import uniq from "@tools/uniq";
import { useMemo } from "react";
import Highlighter from "react-highlight-words";

export const extractHighlightWords = (highlights: any) => {
    let result: string[] = [];
    Object.keys(highlights || {}).forEach(key => {
        let value = highlights[key];
        let highlight_group = value[0];
        let regex           = /<em>(.*?)<\/em>/ig;
        let match = regex.exec(highlight_group);
        while (match)
        {
            result.push(match[1]);
            match = regex.exec(highlight_group);
        }
    });
    return result;
};

interface Props {
    text: string
    highlight: any
}

const Highlight = (props: Props) => {
    const {text, highlight} = props;
    // const result = useMemo(() => {
    //     const uniqWords = uniq(extractHighlightWords(highlight))
    //     let result = text || "";
    //     for(let word of uniqWords) {
    //         if(word){
    //             let regex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, "gim")
    //             if(result.replace)
    //                 result = result.replace(regex, "<em style='background-color:#ffc069'>$&</em>")
    //         }
    //     }
    //     return result
    // }, [highlight, text])

    // return <div dangerouslySetInnerHTML={{__html: result}} />
    return <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={extractHighlightWords(highlight)}
        autoEscape
        textToHighlight={text.toString() || ""}
    >
        {text}
    </Highlighter>
};

export default Highlight
